import {injectIntl, FormattedMessage} from 'react-intl';
import React from 'react';
import PropTypes from 'prop-types';
import "./Scenario.scss";
import ScenarioIcon from './ScenarioIcon.react';
import ScenarioBoxAsWizard from './ScenarioBoxAsWizard.react';
import urlMapping from '../app/URLMapping';

class ScenarioWizard extends React.Component {

    static propTypes = {
		children: PropTypes.any,
		data: PropTypes.object,
		description: PropTypes.object,
		step: PropTypes.number,
		title: PropTypes.object,
		type: PropTypes.object,
    };

    render() {
        let scenario = this.props.data.scenario;

		if (!scenario && this.props.data.scenarios && this.props.data.scenarios.edges && this.props.data.scenarios.edges.length > 0) {
            scenario = this.props.data.scenarios.edges[0].node;
        }

        if (!scenario) {
			return (<div>{this.props.children}</div>);
		}

		let showDescription = this.props.step !== 1 && this.props.step !== 4;

		return (
			<div className="scenarioWizard">
				<div className="scenario-header">
					<div className="left">
						<ScenarioIcon scenario={scenario} />
					</div>
					<div className="main">
						<span className="flex"></span>
						<h2>{this.props.title || <FormattedMessage defaultMessage="Scenario activation" id="channelWizard.activationHeader" />}</h2>
						{showDescription ? (this.props.description || <FormattedMessage defaultMessage="Some services needs activation before we can apply this scenario." id="scenarioWizard.activationDescription" />) : null }
						<span className="flex"></span>
					</div>
				</div>
				<div className="scenario-body">
					<div className="left">
						<ScenarioBoxAsWizard activeChannel={this.props.data.organisation ? this.props.data.organisation.channel : null} activeChannelDef={this.props.data.channelDef} organisation={this.props.data.organisation} scenario={scenario} urlMapping={urlMapping} />
					</div>
					<div className="main">
						{this.props.children}
					</div>
				</div>
			</div>
		);
    }
}

export default injectIntl(ScenarioWizard);
